import React, { Component } from 'react'
import styled from 'styled-components'
import CaretIcon from '../../UI/Icons/CaretIcon'
import { connect } from 'react-redux'
import { fluidType, device, priceFormatted, getNetPrice, getTax } from '../../../utils/helpers'

export const TData = styled.td`
  background-color: #e2e2e2;
  color: #4d4d4d;
  text-transform: uppercase;
  font-family: 'BarlowSemiBold';
  padding: 10px 15px;
  border: 1px solid #ccc;
  white-space: nowrap;
  text-align: right;
  cursor: pointer;
  font-size: 11px;
  ${'' /* ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      '11px',
      '21px'
    )
}; */}

  &:first-child {
    font-family: 'BarlowExtraBold';
    background-color: #f3f3f3;
    text-align: left;
    border-left: none;
  }

  &:last-child {
    font-family: 'BarlowExtraBold';
    background-color: #f3f3f3;
    border-right: none;
  }

  ${'' /* @media ${device.laptop} {
    padding: 17px 25px;
  } */}
  @media ${device.tablet} {
    padding: 0.8854166666666667vw 1.3020833333333335vw;
    font-size: 1.09375vw;
  }
`

const List = styled.div`
  padding-left: 15px;

  @media ${device.tablet} {
    padding-left: 0.78125vw;
  }
`

const Item = styled.div`
  font-family: 'BarlowSemiBold';
  line-height: 1.2em;

  @media ${device.tablet} {
    line-height: 0.9895833333333334vw;
  }
`

const MainItem = styled.div`
  color: ${props => props.price && '#999999'};
  font-size: 11px;
  ${'' /* ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      '11px',
      '16px'
    )
}; */}

  @media ${device.tablet} {
    font-size: 0.8333333333333334vw;
  }
`

const SubItem = styled.div`
  color: #999999;
  font-size: 9px;

  ${'' /* ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      '9px',
      '14px'
    )
}; */}
  @media ${device.tablet} {
    font-size: 0.7291666666666667vw;
  }
`

const Address = styled.div`
  text-transform: none;
`

class TableRow extends Component {
  state = {
    collapsed: true
  }

  toggleExpansion () {
    this.setState({ collapsed: !this.state.collapsed })
  }

  render () {
    const { item, coefficient } = this.props
    const { collapsed } = this.state
    return (
      <tr onClick={this.toggleExpansion.bind(this)}>
        <TData>
          <CaretIcon transform={!collapsed ? 'rotate(90)' : undefined} width='6' fill='#4d4d4d' /> &nbsp; {item.name}
          {!collapsed && <List>
            {item.selectedComponent
              ? <Item>
                <MainItem>{item.index === 5
                  ? <Address>
                    <span>Indirizzo:<br /></span>
                    {item.selectedComponent.split(';').map(line => <span style={{ color: '#999999' }}>{line} <br /></span>)}
                  </Address>
                  : item.selectedComponent}</MainItem>
              </Item>
              : item.components.map(component => {
                if (component.selected) {
                  return (
                    <Item>
                      <MainItem>- {component.name}</MainItem>
                      {component.details && component.details.map(detail => {
                        return (
                          <SubItem>{detail}</SubItem>
                        )
                      })}
                    </Item>
                  )
                }
              })}
          </List>}
        </TData>
        <TData>
          {item.net &&
            priceFormatted(
              item.index === 5
                ? Math.round(getNetPrice(item.price))
                : Math.round(item.net
                  + (item.net * coefficient)
                )
            )
          }
          {!collapsed && <List>
            {item.components && item.components.map(component => {
              if (component.selected) {
                return (
                  <Item>
                    <MainItem price>+ {priceFormatted(Math.round(component.net + (component.net * coefficient)))}</MainItem>
                    {component.details && component.details.map(detail => {
                      return (
                        <SubItem>&nbsp;</SubItem>
                      )
                    })}
                  </Item>
                )
              }
            })}
          </List>}
        </TData>
        <TData>
          {item.tax &&
            priceFormatted(
              item.index === 5
                ? Math.round(getTax(item.price))
                : Math.round(item.tax
                  + (item.tax * coefficient)
                )
            )
          }
          {!collapsed && <List>
            {item.components && item.components.map(component => {
              if (component.selected) {
                return (
                  <Item>
                    <MainItem price>+ {priceFormatted(Math.round(component.tax + (component.tax * coefficient)))}</MainItem>
                    {component.details && component.details.map(detail => {
                      return (
                        <SubItem>&nbsp;</SubItem>
                      )
                    })}
                  </Item>
                )
              }
            })}
          </List>}
        </TData>
        <TData>
          {item.price &&
            priceFormatted(
              item.index === 5
                ? Math.round(item.price)
                : Math.round(item.price
                  + (item.price * coefficient)
                )
            )
          }

          {!collapsed && <List>
            {item.components && item.components.map(component => {
              if (component.selected) {
                return (
                  <Item>
                    <MainItem price>+ {priceFormatted(Math.round(component.price + (component.price * coefficient)))}</MainItem>
                    {component.details && component.details.map(detail => {
                      return (
                        <SubItem>&nbsp;</SubItem>
                      )
                    })}
                  </Item>
                )
              }
            })}
          </List>}
        </TData>
      </tr>
    )
  }
}

function mapStateToProps (state) {
  return {
    coefficient: state.calculator.coefficient
  }
}

export default connect(mapStateToProps)(TableRow)



// WEBPACK FOOTER //
// ./src/components/Calculator/Table/TableRow.js